import styled from 'styled-components';

export const ContainerCards = styled.div`
  width: 93%;
  margin: auto;
  display: flex;
  flex-direction: row;
`;

export default {
  ContainerCards,
};
